/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Continue_ListeningInputs */

const en_nav_app_continue_listening = /** @type {(inputs: Nav_App_Continue_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue Listening`)
};

const es_nav_app_continue_listening = /** @type {(inputs: Nav_App_Continue_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar escuchando`)
};

/**
* | output |
* | --- |
* | "Continue Listening" |
*
* @param {Nav_App_Continue_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_continue_listening = /** @type {((inputs?: Nav_App_Continue_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Continue_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_continue_listening(inputs)
	return en_nav_app_continue_listening(inputs)
});